import { render, staticRenderFns } from "./table-attachment.vue?vue&type=template&id=4f1facd4"
import script from "./table-attachment.ts?vue&type=script&lang=ts&external"
export * from "./table-attachment.ts?vue&type=script&lang=ts&external"
import style0 from "./table-attachment.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1facd4')) {
      api.createRecord('4f1facd4', component.options)
    } else {
      api.reload('4f1facd4', component.options)
    }
    module.hot.accept("./table-attachment.vue?vue&type=template&id=4f1facd4", function () {
      api.rerender('4f1facd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/table/table-attachment/table-attachment.vue"
export default component.exports